import React from 'react';
import '../styles/Status.css';

const Status = ({ status, className, isIcon, icon }) => {
    return (
        <div className={`d-flex align-items-center gap-1 status ${className}`} style={{ cursor: "pointer", textTransform: "capitalize" }}>
            {isIcon && icon}
            {status === "in_progress" ? "In Progress" : status}
        </div>
    )
}

export default Status